import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowLeft, Users, Briefcase, Megaphone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const ServicesSection = () => {
  const { t, isRTL } = useLanguage();

  const services = [
    {
      icon: Users,
      title: t("Digital Bridge PRO", "ديجيتال بريدج برو"),
      description: t(
        "Join our exclusive community of professionals and entrepreneurs accelerating their digital transformation journey.",
        "انضم إلى مجتمعنا الحصري من المحترفين ورواد الأعمال الذين يسرّعون رحلة التحول الرقمي."
      ),
      href: "/pro",
      external: false,
    },
    {
      icon: Briefcase,
      title: t("Consultation", "الاستشارات"),
      description: t(
        "One-on-one strategic consultation to identify opportunities and create actionable roadmaps for your business.",
        "استشارة استراتيجية فردية لتحديد الفرص وإنشاء خرائط طريق قابلة للتنفيذ لعملك."
      ),
      href: "/consultation",
      external: false,
    },
    {
      icon: Megaphone,
      title: t("Digital Bridge Services", "خدمات ديجيتال بريدج"),
      description: t(
        "Full-service digital marketing and branding solutions tailored to elevate your business presence.",
        "حلول تسويق رقمي وعلامة تجارية متكاملة مصممة للارتقاء بحضور عملك."
      ),
      href: "/work-with-us",
      external: false,
    },
  ];

  return (
    <section className="py-20 lg:py-32 bg-white dark:bg-background" id="services">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-foreground mb-4 tracking-tight">
            {t("I WANT", "أريد")}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {services.map((service, index) => (
            <a
              key={index}
              href={service.href}
              target={service.external ? "_blank" : undefined}
              rel={service.external ? "noopener noreferrer" : undefined}
              className="bg-gray-50 dark:bg-card rounded-2xl p-8 border border-gray-200 dark:border-border hover:border-primary/50 hover:scale-[1.02] transition-all duration-200 cursor-pointer group"
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors">
                  <service.icon className="w-7 h-7 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-foreground mb-2 group-hover:text-primary transition-colors flex items-center gap-2">
                    {service.title}
                    {isRTL ? (
                      <ArrowLeft className="w-5 h-5 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    ) : (
                      <ArrowRight className="w-5 h-5 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    )}
                  </h3>
                  <p className="text-gray-600 dark:text-muted-foreground">
                    {service.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
